import { useMemo } from "react"
import { Badge, Async, Link } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useTransactionHooks } from "../../../hooks/transactionHooks"
import { Transaction, TransactionDestinationType } from "../../../state/types"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"

type Props = {
    transaction: Transaction
}

export const TransactionDestination = (props: Props) => {
    const { transaction } = props

    const { getDestinationTable, describeDestination } = useTransactionHooks()
    const { getRoutePath } = useRoutesHooks()

    const isPaymentOrder = useMemo(() => getDestinationTable(transaction.destinationType) === TableName.PAYMENT_ORDERS, [transaction.destinationType])
    const isCheck = useMemo(() => getDestinationTable(transaction.destinationType) === TableName.CHECKS, [transaction.destinationType])

    const icon = useMemo(() => isPaymentOrder ? 'cash-coin' : 'inbox', [isPaymentOrder])

    const destinationPath = useMemo(() => {
        const tablePath = isPaymentOrder ? RoutePath.PAYMENT_ORDERS : (isCheck ? RoutePath.CHECKS : RoutePath.CASH_FUNDS)
        const idPath = isPaymentOrder ? transaction.destinationId : (isCheck ? transaction.destinationId : undefined)
        return getRoutePath(tablePath, idPath)
    }, [isPaymentOrder, isCheck, transaction.destinationId])

    return <Async
        loadFn={async () => {
            return [
                TransactionDestinationType.MANUAL_SUBSTRACTION,
                TransactionDestinationType.FINANCIAL_COST,
                TransactionDestinationType.CREDIT_IN_FAVOR,
                TransactionDestinationType.ROUNDING
            ].includes(transaction.destinationType) ?
                <Badge label={await describeDestination(transaction)} /> :
                <Link
                    text={await describeDestination(transaction)}
                    icon={icon}
                    kind="primary"
                    to={destinationPath}
                />
        }}
    />
}
